module.exports = __webpack_public_path__ + "static/media/national.eef037a9.png";